import type { OpcaoEmpregado } from '../catalogo-empregado.tipos'

export type ListarOpcoesEmpregadoRepositorio = (
  sinal: AbortSignal,
) => Promise<readonly OpcaoEmpregado[]>

export const criarCasoDeUsoListarOpcoesEmpregado = (
  listarNoRepositorio: ListarOpcoesEmpregadoRepositorio,
): ListarOpcoesEmpregadoRepositorio => async (sinal) => (
  listarNoRepositorio(sinal)
)
